let addShadeFilterEvent = (rootEl) => {
  rootEl.querySelectorAll('.product-block-shade-filter input').forEach((el) => {
    el.addEventListener('change', (evt) => {
      evt.preventDefault();
      let $this = evt.target;
      let productOptions = $this.closest('.product__option')? $this.closest('.product__option') : $this.closest('.product-block-shade-filter').nextElementSibling.querySelector('.product__option');
      let shadeModal = document.querySelector('.modal:not(.quick-product--wrap).active .modal__inner .shade_popup');
      let shadeButtons;

      if (shadeModal) {
        shadeButtons = shadeModal.querySelectorAll('.product__color-swatches--inner button');
        
        let filterItems = document.querySelectorAll('.modal:not(.quick-product--wrap).active .modal__inner .filter_input input');

        filterItems.forEach((filterItem) => {
          filterItem.checked = filterItem.id === el.id; 
        });

        const optionElement = shadeModal.querySelector('[data-selected-value-for-option]');
        const messageElement = shadeModal.querySelector('[data-selected-value-message]');
        const imageElement = shadeModal.querySelector('img.shade_item-image');

        if (optionElement) optionElement.textContent = "";
        if (messageElement) messageElement.textContent = "";
        if (imageElement) {
          // Store the original image source if not already stored
          if (!imageElement.dataset.originalSrc && imageElement.src && !imageElement.src.includes('data:image/svg+xml')) {
            imageElement.dataset.originalSrc = imageElement.src;
          }
          imageElement.src = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMSIgaGVpZ2h0PSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIxIiBoZWlnaHQ9IjEiIGZpbGw9IndoaXRlIi8+PC9zdmc+";
        }

      } else {
        shadeButtons = productOptions.querySelector('.product__color-swatches--inner').querySelectorAll('button');
      }

      if ($this.value === 'all') {
        shadeButtons.forEach((swatch) => {
          swatch.style.display = "block";
          swatch.classList.remove('selected');
        });
        
        // Restore the original default image when switching back to "all"
        if (shadeModal) {
          const imageElement = shadeModal.querySelector('img.shade_item-image');
          if (imageElement) {
            // Check if we have a stored original image, otherwise use the first available shade image
            const originalImageSrc = imageElement.dataset.originalSrc;
            if (originalImageSrc) {
              imageElement.src = originalImageSrc;
            } else {
              // Try to get the first shade image as fallback
              const optionContent = document.querySelector('.product__option-popup-content');
              const imageData = optionContent?.querySelector('#popup__images')?.textContent.trim();
              const optionData = optionContent?.querySelector('#option_names')?.textContent.trim();
              
              if (imageData && optionData) {
                try {
                  const imageJson = JSON.parse(imageData);
                  const optionJson = JSON.parse(optionData);
                  const firstShade = Array.from(shadeButtons).find(swatch => swatch.style.display !== "none");
                  if (firstShade) {
                    const imageUrl = imageJson[optionJson.indexOf(firstShade.dataset.optionValue)]?.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
                    if (imageUrl) {
                      imageElement.src = imageUrl;
                    }
                  }
                } catch (e) {
                  // Keep placeholder if all else fails
                }
              }
            }
          }
        }
      } else {
        let shadeMap = $this.getAttribute('data-shades');
        let shadesJSON = {};

        try {
          shadesJSON = JSON.parse(shadeMap);
        } catch (e) { }

        let shades = Object.keys(shadesJSON);
        shadeButtons.forEach((swatch) => {
          if (shades.indexOf(swatch.getAttribute('data-label').replace('+', ' ')) === -1) {
            swatch.style.display = "none";
          } else {
            swatch.style.display = "block";
          }
        
          swatch.classList.remove('selected');
        });

        document.querySelector('[data-selected-value-for-option]').innerText = "";
        document.querySelector('[data-selected-value-message]').innerText = "";
        
        // Restore original image when switching back to specific shade tab
        if (shadeModal) {
          const imageElement = shadeModal.querySelector('img.shade_item-image');
          if (imageElement) {
            // Store the original image source if not already stored
            if (!imageElement.dataset.originalSrc && imageElement.src && !imageElement.src.includes('data:image/svg+xml')) {
              imageElement.dataset.originalSrc = imageElement.src;
            }
            
            // Find the first visible shade button (the first one in the filtered list)
            const firstVisibleShade = Array.from(shadeButtons).find(swatch => 
              swatch.style.display !== "none"
            );
            
            if (firstVisibleShade) {
              // Try to get the image from the shade data
              const optionContent = document.querySelector('.product__option-popup-content');
              const imageData = optionContent?.querySelector('#popup__images')?.textContent.trim();
              const optionData = optionContent?.querySelector('#option_names')?.textContent.trim();
              
              if (imageData && optionData) {
                try {
                  const imageJson = JSON.parse(imageData);
                  const optionJson = JSON.parse(optionData);
                  const imageUrl = imageJson[optionJson.indexOf(firstVisibleShade.dataset.optionValue)]?.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
                  if (imageUrl) {
                    imageElement.src = imageUrl;
                  } else {
                    // If no specific image found, keep the placeholder
                    imageElement.src = "";
                    // imageElement.src = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMSIgaGVpZ2h0PSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIxIiBoZWlnaHQ9IjEiIGZpbGw9IndoaXRlIi8+PC9zdmc+";
                  }
                } catch (e) {
                  // If parsing fails, keep the placeholder
                  imageElement.src = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMSIgaGVpZ2h0PSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIxIiBoZWlnaHQ9IjEiIGZpbGw9IndoaXRlIi8+PC9zdmc+";
                }
              }
            }
          }
        }
      }

    })
  });
}

let productDetail = document.querySelector('.product__details');
if (productDetail) {
  addShadeFilterEvent(productDetail);
}

if (document.getElementsByTagName('body')[0].classList.contains('gift-card') === false) {
  
  // move the shade filter to below the step
  let concealerStep = document.querySelector('.product__option .shade_popup.concealer-shade');
  let shadeFilter = document.querySelector('.product-block-shade-filter');

  if(concealerStep) {
    concealerStep.before(shadeFilter);
  }


  let productDetail = document.querySelector('.product__details');
  if (productDetail) {
    addShadeFilterEvent(productDetail);
  }
}

// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.

// Add this event listener for Rebuy button clicks BEFORE cart update
document.addEventListener('rebuy.beforeAdd', function(event) {
  // Add the class when Rebuy button is clicked (before cart update)
  let quickCartContainer = document.querySelector('.quick-cart');

  // Check if quickCartContainer exists before trying to query it
  if (!quickCartContainer) {
    return;
  }

  let quickCartSubmitButton = quickCartContainer.querySelector(".quick-cart__submit");
  if(quickCartSubmitButton && !quickCartSubmitButton.classList.contains("checkout-button-update")) {
    quickCartSubmitButton.classList.add("checkout-button-update");
    // quickCartSubmitButton.innerHTML = window.ThemeSpinner.getSpinnerWithText("Updating bag..");

    quickCartSubmitButton.innerHTML = `
      <span class="decorative-line-left"></span>
      <span class="button-content">
        ${window.ThemeSpinner.getSpinnerWithText("Updating bag..")}
      </span>
      <span class="decorative-line-right"></span>
    `;

  }

});

document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);

}); // This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.


document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
  let cart = evt.detail.cart;

  let cartItemsCount = cart.item_count;
  let cartItemCountEle = document.querySelector('.quick-cart__heading span');
  if(cartItemCountEle) {
    cartItemCountEle.textContent = `(${cartItemsCount} ITEMS)`;
  }
}); // This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
}); // This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

// Guard flag to prevent infinite loops when syncing variant selections
let isUpdatingVariant = false;

document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);

  // Prevent recursive calls - if we're already updating, skip
  if (isUpdatingVariant) {
    console.log("Skipping recursive variant update");
    return;
  }

  let data = evt.detail.variant;
  let shadepopups = document.querySelectorAll(".shade_popup");

  if (shadepopups.length > 0) {
    // Set flag to prevent recursive calls
    isUpdatingVariant = true;
    
    shadepopups.forEach(shadepopup => {
      // Get which option this shade popup belongs to (option1, option2, or option3)
      const optionButtons = shadepopup.querySelector('[data-option-buttons]');
      if (!optionButtons) return;
      
      const optionPosition = optionButtons.getAttribute('data-product-option'); // e.g., "option1", "option2"
      
      // Only update the visual state (selected class), don't click buttons
      // Clicking buttons triggers more variant changes and creates infinite loops
      const allButtons = shadepopup.querySelectorAll('button.product__color-swatch');
      
      // Remove selected class from all buttons first
      allButtons.forEach(btn => btn.classList.remove('selected'));
      
      // IMPORTANT: Only select the button that matches THIS option's value
      // Don't select buttons for other option values!
      let optionValue = null;
      if (optionPosition === 'option1') optionValue = data.option1;
      else if (optionPosition === 'option2') optionValue = data.option2;
      else if (optionPosition === 'option3') optionValue = data.option3;
      
      if (optionValue) {
        const btn = shadepopup.querySelector(`button[data-option-value="${optionValue}"]`);
        if (btn) {
          btn.classList.add('selected');
        }
      }
    });
    
    // Don't click select_option buttons automatically - this causes unwanted variant updates
    // The user should explicitly click "Select" when they want to confirm their choice
    
    // Clear flag after a short delay to allow event propagation to complete
    setTimeout(() => {
      isUpdatingVariant = false;
    }, 100);
  }


}); // This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.

document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
}); // This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.

document.addEventListener("quickview:loaded", function (evt) {
  console.log("Quickview loaded");
  addShadeFilterEvent(evt.detail.product);

  var tablists = document.querySelectorAll('[role=tablist].automatic');
  for (var i = 0; i < tablists.length; i++) {
    new TabsAutomatic(tablists[i]);
  }
}); 

document.querySelectorAll('.toggle-button').forEach((el) => {
  el.addEventListener('click', (evt) => {
    evt.preventDefault();
    let $this = evt.target
    let isExpanded = $this.getAttribute('aria-expanded');

    if (typeof isExpanded === 'undefined' || isExpanded === null) {
      $this = $this.parentElement;
      isExpanded = $this.getAttribute('aria-expanded');
    }

    if (isExpanded === 'false') {
      document.querySelectorAll('.toggle-button').forEach((tb) => { tb.setAttribute('aria-expanded', false); });
      $this.setAttribute('aria-expanded', true);

      let imageTextBlocks = document.querySelectorAll('.list-of-image-with-text .image-with-text');
      let block = $this.getAttribute('data-block');
      let section = document.querySelector('.list-of-image-with-text .image-with-text[data-block="' + block + '"]');
      let backgroundContainer = document.querySelector('.background-container');

      //set toggle button background
      if (section.getAttribute('data-index') == 1) {
        backgroundContainer.style.transform = "translateX(0)";
      } else if (section.getAttribute('data-index') == imageTextBlocks.length) {
        backgroundContainer.style.transform = "translateX(200%)";
      } else {
        backgroundContainer.style.transform = "translateX(100%)";
      }

      document.querySelectorAll('.list-of-image-with-text .image-with-text').forEach((it) => {
        it.classList.remove('active');
        it.setAttribute('aria-hidden', 'true');
        it.querySelector('.btn').setAttribute('aria-hidden', 'true');
      });
      section.classList.add('active');
      section.setAttribute('aria-hidden', 'false');
      section.querySelector('.btn').setAttribute('aria-hidden', 'false');
    }

  });
});

let bindGridEvents = () => {
  document.querySelectorAll('input[name="option-0"]').forEach((el) => {
    el.addEventListener('change', (evt) => {
      let $target = evt.target;
      let variantId = $target.getAttribute('data-variant-id');
      let variantData = $target.getAttribute('data-variant');
      let preOrder = $target.getAttribute('data-pre-order');
      let releaseDate = $target.getAttribute('data-release-date');
      let isSoldOut =  (String($target.getAttribute('data-is-soldout')).toLowerCase() === 'true');
      let isComingSoon = (String($target.getAttribute('data-is-comingsoon')).toLowerCase() === 'true');
      let variantDesc = $target.getAttribute('data-desc');
      let variantImage1 = $target.getAttribute('data-image-one');
      let variantImage2 = $target.getAttribute('data-image-two');

      //set selected
      $target.closest('.product-swatches-options').querySelector('[type="hidden"]').value = variantId;
      $target.closest('.product-swatches-options').querySelector('.product-swatches-options__selected').innerText = $target.value;
    
      const propInput = document.createElement("Input");
      propInput.setAttribute('type', 'hidden');
      propInput.setAttribute('name', 'properties[status]');
      propInput.setAttribute('value', 'Pre-Order. Ship date ' + preOrder);

      //check selected variant status and price
      try {
        variantJSON = JSON.parse(variantData);
      } catch (e) { }

      // - button status
      let productForm = $target.closest('.shopify-product-form');
      let addToCartBtn = productForm.querySelector('button[name="add"]');
      let notifyBtn = productForm.querySelector('a.klaviyo-bis-trigger');
      let shipDate = productForm.querySelector('.ship_date');
      let releaseDateEl =  productForm.querySelector('.release_date');

      addToCartBtn.classList.remove('btn--choose_option');
      addToCartBtn.parentElement.querySelector('input[name="properties[status]"]') && addToCartBtn.parentElement.querySelector('input[name="properties[status]"]').remove();
      
      addToCartBtn.style.display = 'flex';
      notifyBtn.style.display = 'none';


      if (variantJSON && variantJSON.available && variantJSON.inventory_quantity <= 0 && preOrder !== '') {
        // -- pre-order
        addToCartBtn.removeAttribute('disabled');
        addToCartBtn.classList.remove('sold-out');
        addToCartBtn.querySelector('.button-text').innerText = 'Pre-Order';
        shipDate.classList.add('visible');
        shipDate.innerText = "Ship date of " + preOrder;
        shipDate.after(propInput);
      } else if (variantJSON && !variantJSON.available) {
        // -- sold out
        if (isSoldOut) {
          // -- sold out
          addToCartBtn.setAttribute('disabled', 'disabled');
          addToCartBtn.classList.add('sold-out');
          addToCartBtn.querySelector('.button-text').innerText = 'Sold Out';
        } else if (isComingSoon) {
          // -- coming soon
          addToCartBtn.setAttribute('disabled', 'disabled');
          addToCartBtn.classList.add('sold-out');
          addToCartBtn.querySelector('.button-text').innerText = 'Coming Soon';
          if (releaseDate != '') {
            releaseDateEl.classList.add('visible');
            releaseDateEl.innerText = "Release date of " + releaseDate;
          }
        } else {
          // -- notify me
          addToCartBtn.style.display = 'none';
          notifyBtn.style.display = 'flex';
          shipDate.classList.remove('visible');
          releaseDateEl.classList.remove('visible');
        }
      } else {
        // -- available atc
        addToCartBtn.removeAttribute('disabled');
        addToCartBtn.classList.remove('sold-out');
        addToCartBtn.querySelector('.button-text').innerText = 'Add To Bag';
        shipDate.classList.remove('visible');
        releaseDateEl.classList.remove('visible');
      }

      // - price
      let priceWrapper = productForm.querySelector('.product-item__price');
      if(priceWrapper == null) {
          priceWrapper = productForm.closest('.product-item__meta').querySelector('.product-item__price');
      }
        let autoBadge = priceWrapper.getAttribute('data-auto-badge');
        let discountPercentage = 0, discountAmount = 0;
        let discountPrice = $target.getAttribute('data-discount-price');

        if (autoBadge) {
          if (autoBadge.indexOf('%') !== -1) {
            discountPercentage = autoBadge.replace('%', '').replace('off', '').replace(/ /g, '');
            discountPercentage = (100 - Number(discountPercentage)) * 0.01;
          } else if (autoBadge.indexOf('$') !== -1) {
            discountAmount = autoBadge.replace('$', '').replace('off', '').replace(/ /g, '');
            discountAmount = Number(discountAmount) * window.Shopify.currency.rate;
          }
        }

        if (discountPercentage > 0) {
          if (variantJSON.compare_at_price >= variantJSON.price) {
            priceWrapper.innerHTML = '<span class="visually-hidden visually-hidden--inline">Regular price</span>'
              + '<s class="t-subdued">$' + parseFloat(variantJSON.compare_at_price / 100).toFixed(2) + '</s>'
              + '<span class="visually-hidden visually-hidden--inline">Sale price</span><span class="sale" data-price>$' + parseFloat(variantJSON.price / 100 * discountPercentage).toFixed(2) + '</span>';
          } else {
            priceWrapper.innerHTML = '<span class="visually-hidden visually-hidden--inline">Regular price</span>'
              + '<s class="t-subdued">$' + parseFloat(variantJSON.price / 100).toFixed(2) + '</s>'
              + '<span class="visually-hidden visually-hidden--inline">Sale price</span><span class="sale" data-price>$' + parseFloat(variantJSON.price / 100 * discountPercentage).toFixed(2) + '</span>';
          }
        } else if (discountAmount > 0) {
          if (variantJSON.compare_at_price >= variantJSON.price) {
            priceWrapper.innerHTML = '<span class="visually-hidden visually-hidden--inline">Regular price</span>'
              + '<s class="t-subdued">$' + parseFloat(variantJSON.compare_at_price / 100).toFixed(2) + '</s>'
              + '<span class="visually-hidden visually-hidden--inline">Sale price</span><span class="sale" data-price>$' + parseFloat(variantJSON.price / 100 - discountAmount).toFixed(2) + '</span>';
          } else {
            priceWrapper.innerHTML = '<span class="visually-hidden visually-hidden--inline">Regular price</span>'
              + '<s class="t-subdued">$' + parseFloat(variantJSON.price / 100).toFixed(2) + '</s>'
              + '<span class="visually-hidden visually-hidden--inline">Sale price</span><span class="sale" data-price>$' + parseFloat(variantJSON.price / 100 - discountAmount).toFixed(2) + '</span>';
          }

        } else if (discountPrice !== '' && parseFloat(discountPrice) > 0) {
          priceWrapper.innerHTML = '<span class="visually-hidden visually-hidden--inline">Regular price</span>'
          + '<s class="t-subdued">$' + parseFloat(variantJSON.price / 100).toFixed(2) + '</s>'
          + '<span class="visually-hidden visually-hidden--inline">Sale price</span><span class="sale" data-price>$' + parseFloat(discountPrice / 100).toFixed(2) + '</span>';
        } else {
          if (variantJSON.compare_at_price >= variantJSON.price) {
            priceWrapper.innerHTML = '<span class="visually-hidden visually-hidden--inline">Regular price</span>'
              + '<s class="t-subdued">$' + parseFloat(variantJSON.compare_at_price / 100).toFixed(2) + '</s>'
              + '<span class="visually-hidden visually-hidden--inline">Sale price</span><span class="sale" data-price>$' + parseFloat(variantJSON.price / 100).toFixed(2) + '</span>';
          } else {
            priceWrapper.innerHTML = '<span data-price>$' + parseFloat(variantJSON.price / 100).toFixed(2) + '</span>';
          }
        }
      

      //update selected variant Images
      let productImageMedia = productForm.closest('.product-item__inner').querySelector('.product-item__media');
      let imageOne = productImageMedia.querySelectorAll('.product-item__image')[0];
      let imageTwo = productImageMedia.querySelectorAll('.product-item__image').length > 1 ? productImageMedia.querySelectorAll('.product-item__image')[1] : null;

      if (imageOne && variantImage1) {
        imageOne = imageOne.querySelector('img');
        imageOne.setAttribute('alt', $target.value);
        imageOne.setAttribute('src', variantImage1);

        let imageUrl = variantImage1.split('&')[0];
        let newImageSrcset = '';
        let src_set_widths_raw = [150, 200, 240, 280, 300, 360, 400, 450, 500, 550, 600, 650, 700, 750, 800, 850, 900, 950, 1000, 1100, 1200, 1300, 1400];
        if ($target.getAttribute('data-aspect-ratio') === 'portrait') {
          src_set_widths_raw.forEach(function (width, index) {
            newImageSrcset += imageUrl + '&crop=center&height=' + width * 3 / 2 + '&width=' + width + ' ' + width + 'w,';
          });
        } else {
          src_set_widths_raw.forEach(function (width, index) {
            newImageSrcset += imageUrl + '&crop=center&height=' + width + '&width=' + width + ' ' + width + 'w,';
          });
        }

        imageOne.setAttribute('srcset', newImageSrcset);
      }

      if (imageTwo && variantImage2) {
        imageTwo = imageTwo.querySelector('img');
        imageTwo.setAttribute('alt', $target.value);
        imageTwo.setAttribute('src', variantImage2);

        let imageUrl = variantImage2.split('&')[0];
        let newImageSrcset = '';
        let src_set_widths_raw = [150, 200, 240, 280, 300, 360, 400, 450, 500, 550, 600, 650, 700, 750, 800, 850, 900, 950, 1000, 1100, 1200, 1300, 1400];
        if ($target.getAttribute('data-aspect-ratio') === 'portrait') {
          src_set_widths_raw.forEach(function (width, index) {
            newImageSrcset += imageUrl + '&crop=center&height=' + width * 3 / 2 + '&width=' + width + ' ' + width + 'w,';
          });
        } else {
          src_set_widths_raw.forEach(function (width, index) {
            newImageSrcset += imageUrl + '&crop=center&height=' + width + '&width=' + width + ' ' + width + 'w,';
          });
        }

        imageTwo.setAttribute('srcset', newImageSrcset);
      }

      // update short description
      var description = $target.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.getElementsByClassName('product-item__product-description');
      if (description.length) {
        description = description[0];

        if (variantDesc) {
          description.innerText = variantDesc;
        } else {
          description.innerText = description.getAttribute("data-desc");
        }
      }

    });
  });

  //variant level on page load
  document.querySelectorAll('input[data-pre-selected]').forEach((el) => {
    el.click();
    el.parentElement.style.display = 'block';
  });

  document.querySelectorAll('.product-swatches-options__item, .product-swatches-options__item-overflow-note:not(.no-click)').forEach((el) => {
    // prevent focus passing
    el.addEventListener('focus', event => {
      event.preventDefault();
    });

    // activate using spacebar
    el.addEventListener('keyup', event => {
      if (event.keyCode == 32 || event.keyCode == 13) {
        el.click();
      }
    });
  });

  if(window.location.pathname.indexOf('/quiz') === -1 && window.location.pathname.indexOf('/quiz-categorized') === -1) {
    document.querySelectorAll('.product-swatches-options__item-overflow-note:not(.no-click)').forEach((el) => {
      let swatchesList = el.parentElement;
      let listSize = swatchesList.querySelectorAll('li:not(.product-swatches-options__item-overflow-note)').length;

      if (window.matchMedia("(max-width: 1112px)").matches) {
        if (listSize <= 4) {
          el.style.display = 'none';
        }

      } else if (window.matchMedia("(max-width: 960px)").matches) {
        if (listSize <= 5) {
          el.style.display = 'none';
        }
      } else if (window.matchMedia("(max-width: 480px)").matches) {
        if (listSize <= 4) {
          el.style.display = 'none';
        }
      } else if (window.matchMedia("(max-width: 1300px)").matches) {
        if (listSize <= 5) {
          el.style.display = 'none';
        }
      } else if (window.matchMedia("(max-width: 1490px)").matches) {
        if (listSize <= 6) {
          el.style.display = 'none';
        }
      }else {
        if (listSize <= 6) {
          el.style.display = 'none';
        }
      }


      el.addEventListener('click', (evt) => {
        evt.preventDefault();
        let target = evt.target;
      
        swatchesList.querySelectorAll('li:not(.product-swatches-options__item-overflow-note)').forEach((li) => {
          li.style.display = "block";
        });

        if(target.className.indexOf('overflow_amount') !== -1) {
          target = evt.target.parentElement;
        }

        target.style.display = 'none';

      });
    });
  }
}

bindGridEvents();

if (window.location.pathname.indexOf('/products') !== -1 && document.querySelector('.product-tabs__mobile-accordions a.open-ingredient-list')) {
  document.querySelector('.product-tabs__mobile-accordions a.open-ingredient-list').addEventListener('click', (evt) => {
    evt.preventDefault();

    let fullIngredientList = document.querySelector('.product-tabs__mobile-accordions .full-ingredient-list');
    fullIngredientList.classList.add('visible');
    fullIngredientList.classList.add('animation--popup-revealed');
  });


  document.querySelector('.product-tabs__mobile-accordions .popup.full-ingredient-list .popup__dismiss-icon').addEventListener('click', (evt) => {
    evt.preventDefault();

    let fullIngredientList = document.querySelector('.product-tabs__mobile-accordions .full-ingredient-list');
    fullIngredientList.classList.remove('visible');
    fullIngredientList.classList.remove('animation--popup-revealed');
  });
}

if (window.location.pathname.indexOf('/pages/') !== -1 &&document.querySelector('a.open-ingredient-list')) {
  document.querySelector('a.open-ingredient-list').addEventListener('click', (evt) => {
    evt.preventDefault();

    let fullIngredientList = document.querySelector('.full-ingredient-list');
    fullIngredientList.classList.add('visible');
    fullIngredientList.classList.add('animation--popup-revealed');
  });


  document.querySelector('.popup.full-ingredient-list .popup__dismiss-icon').addEventListener('click', (evt) => {
    evt.preventDefault();

    let fullIngredientList = document.querySelector('.full-ingredient-list');
    fullIngredientList.classList.remove('visible');
    fullIngredientList.classList.remove('animation--popup-revealed');
  });
}

let galleryItemLabel = document.querySelectorAll('.gallery-item__label');
if (galleryItemLabel.length > 0) {
  galleryItemLabel.forEach((g) => { 
    let galleryItemTitle = g.querySelector('.gallery-item__title');
    let galleryItemP = g.querySelector('p');

    if (galleryItemTitle.textContent.indexOf('$') !== -1) {
      let title = galleryItemTitle.textContent;
      galleryItemTitle.textContent = '$' + Math.ceil(parseInt(title.replace('$', ''), 10) * window.Shopify.currency.rate);
    }

    if (galleryItemP.textContent.indexOf('$') !== -1) {
      let text = galleryItemP.textContent;
      let price = text.split('$')[1].split('/')[0];
      let priceWithCurrency = Number(price) * window.Shopify.currency.rate;
      galleryItemP.textContent = text.replace(price, (Math.round(priceWithCurrency * 100)/100).toFixed(2));
    }
  });
}


if (window.location.pathname.indexOf('/products') !== -1 && document.querySelectorAll('.product-tabs__mobile-accordions').length) {
  let button = [...document.querySelectorAll('.accordion__label')].filter(al => {
      return al.textContent.toLowerCase().indexOf('description') !== -1;
    }).pop();
  
  let descriptionElementArr = [...button.nextElementSibling.querySelector('.product-tabs__tab-text').children];
  let nonEmptyArr = descriptionElementArr.filter(c => c.textContent !== '');
  let reviewElement = nonEmptyArr[nonEmptyArr.length - 1];
  if (reviewElement.tagName !== 'em') {
    reviewElement = reviewElement.querySelector('em');
  }

  if (reviewElement) {
    reviewElement.classList.add('style-review');
  
    let splitReview = reviewElement.textContent.split('" -');
    if (splitReview.length <= 1) {
      splitReview = reviewElement.textContent.split('" -');
    }

    if (splitReview.length <= 1) {
      splitReview = reviewElement.textContent.split('” -');
    }

    reviewElement.innerHTML = '<span>' + splitReview[0] + '"</span>';
    
    if (splitReview.length > 1) {
      reviewElement.innerHTML += '<span class="signature"><i>' + splitReview[1].trim().charAt(0) + '</i><span>' + splitReview[1].trim() + '</span></span>';
    }
  }

}

let optionalGCFields = document.getElementById('add-gift-message-optional');
if (optionalGCFields) {
  optionalGCFields.addEventListener('click', (evt) => {

    let optionalGCMsg = document.querySelector('.optional_gift_message');
    if (optionalGCMsg.getAttribute('aria-expanded') === 'true') {
      optionalGCMsg.setAttribute('aria-expanded', false);
    } else {
      optionalGCMsg.setAttribute('aria-expanded', true);
    }
  });
}

document.querySelectorAll('.header__inner a, .header__inner button, .footer__inner a, .footer__inner button').forEach((link) => {
  link.addEventListener('click', (e) => {
    if (typeof eraseCookie === 'function') {
      eraseCookie('fromStakFlow');
    }
  });
});

document.querySelectorAll('.image-hero-with-cart .cart-items .cart-item .cart-item-quantity-wrapper .cart-item-remove').forEach((removeBtn) => {
  removeBtn.addEventListener('click', (e) => {
    e.preventDefault();
    let button = e.target.tagName === 'button' ? e.target : e.target.closest('button');
    let variantId = button.getAttribute('data-variant-id');

    let formData = new FormData();
    formData.append("updates["+variantId+"]", 0);
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => window.location.reload());
  });
});

var inPageSubmitBtn = document.querySelector('.product-form__controls-group--submit');
var stickySubmitBtn = document.querySelector('.product-sticky-bottom');
var isScrolledIntoView = (el) => {
  var rect = el.getBoundingClientRect();
  var elemTop = rect.top;
  var elemBottom = rect.bottom;

  // Only completely visible elements return true:
  var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
  // Partially visible elements return true:
  //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
  return isVisible;
}

if(inPageSubmitBtn && stickySubmitBtn) {
  window.addEventListener('load', (evt) => {
    // always hide on page load
    stickySubmitBtn.style.display = 'none';
  });

  window.addEventListener('scroll', (evt) => {
    let isVisible = isScrolledIntoView(inPageSubmitBtn);
    if(document.querySelector('.premade-stak__product-details')) {
      isVisible = !!document.querySelector('.product__option-step:not(.selected)');
    }

    if(isVisible) {
      stickySubmitBtn.style.display = 'none';
    } else {
      stickySubmitBtn.style.display = 'block';
    }
  });

  window.addEventListener('resize', (evt) => {
    let isVisible = isScrolledIntoView(inPageSubmitBtn);

    if(document.querySelector('.premade-stak__product-details')) {
      isVisible = !!document.querySelector('.product__option-step:not(.selected)');
    }

    if(isVisible) {
      stickySubmitBtn.style.display = 'none';
    } else {
      stickySubmitBtn.style.display = 'block';
    }
  });

  window.addEventListener('orientationchange', (evt) => {
    let isVisible = isScrolledIntoView(inPageSubmitBtn);

    if(document.querySelector('.premade-stak__product-details')) {
      isVisible = !!document.querySelector('.product__option-step:not(.selected)');
    }

    if(isVisible) {
      stickySubmitBtn.style.display = 'none';
    } else {
      stickySubmitBtn.style.display = 'block';
    }
  });
}

if(document.getElementsByTagName('body')[0].classList.contains('bfcm-landing')) {
  document.querySelectorAll('a[href="#"]').forEach((bttel) => {
    bttel.addEventListener('click', (evt) => {
      evt.preventDefault();
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    });
  });
}


if (window.location.pathname.indexOf('/pages') !== -1) {
  document.addEventListener('DOMContentLoaded', function() {
    const upsellBlock = document.querySelector('.featured-upsell_block');
    const upsellProduct = document.querySelector('.featured-upsell');
    
    if(upsellBlock && upsellProduct){
      document.querySelector('.featured-product .product-form')?.after(upsellBlock);
      const upsellVariant = upsellBlock.querySelector('.upsell__product-variant');
      const variantOptions = upsellProduct.querySelectorAll('.product__variants-wrapper .js-enabled.product__option');

      variantOptions.forEach((item) => {
        const stepHandle = item.querySelector('.product__option-step')?.getAttribute('data-option-handle');
        const mainStepElement = document.querySelector(`.featured-product .product__option-step[data-option-handle="${stepHandle}"]`);

        if (!mainStepElement) {
          const clonedElement = item.cloneNode(true); 
          upsellVariant.appendChild(clonedElement);
        }
      });


      upsellBlock.style.display="block";

      upsellBlock.querySelectorAll('.js-enabled.product__option').forEach(item => {
        item.addEventListener('click', function() {
          const itemHandle = item.querySelector('.product__option-step').getAttribute('data-option-handle');
          upsellProduct.querySelector(`.product__option-step[data-option-handle="${itemHandle}"]`)?.click();
        })
      })

      const upsellButton = upsellBlock.querySelector('button.upsells__item-add');
      upsellButton.addEventListener('click', function(e) {
        upsellButton.querySelector('span.upsells__text-add').style.display="none;"
        upsellButton.querySelector('.btn__loading-wrap').style.display="block;"
        
        let ableTo = true;
        let mainOptionUnselected = false;

        for (let item of variantOptions) {
          const selectedOption = item.querySelector('span[data-selected-value-for-option]')?.textContent;
          
          if (!selectedOption || selectedOption.trim() == '') {
            const stepHandle = item.querySelector('.product__option-step')?.getAttribute('data-option-handle');
            const mainStepElement = document.querySelector(`.featured-product .product__variants-wrapper .product__option-step[data-option-handle="${stepHandle}"]`);
            const blockStepElement = upsellBlock.querySelector(`.product__option-step[data-option-handle="${stepHandle}"]`);
            
            if(blockStepElement) {
              blockStepElement.classList.add('unselected');
            }

            if(mainStepElement) {
              mainStepElement.classList.add('unselected');
              mainOptionUnselected = true;
            }
            ableTo = false;
          } 
        }

        if(ableTo) {
          const variantIdToRemove = document.querySelector('.featured-product .product-form__variants select#variant-selector').value;

          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              const itemToRemove = cart.items.find(item => item.variant_id == variantIdToRemove);
              
              if (!itemToRemove) {
                upsellProduct.querySelector('button.product-form__cart-submit')?.click();
                return null;
              }

              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: itemToRemove.key,
                  quantity: 0
                })
              });
            })
            .then(response => {
              if (response) return response.json();
            })
            .then(data => {
              if (data) console.log('Item removed:', data);
              upsellProduct.querySelector('button.product-form__cart-submit')?.click();
            })
            .catch(error => {
              console.error('Cart operation error:', error);
            });

        } 

        if(mainOptionUnselected) {
          const section = document.querySelector('.featured-product');

          window.scrollTo({
            top: section.offsetTop,
            behavior: 'smooth'
          });
        }

        upsellButton.querySelector('span.upsells__text-add').style.display="block;"
        upsellButton.querySelector('.btn__loading-wrap').style.display="none;"
      })
    }
  })
}

if (window.location.pathname.indexOf('/premade-staks') !== -1 
|| window.location.pathname.indexOf('/pages/buildmystack') !== -1
|| window.location.pathname.indexOf('/pages/bfcm') !== -1
|| window.location.pathname === '/') {
  document.addEventListener('DOMContentLoaded', function() {

    // Footer quiz link
    const resultLink = document.querySelector('.take-quiz__bottom .btn--callout');
    if (resultLink) { 
      resultLink.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        evt.stopPropagation();

        if(document.querySelector('.email-wrapper') === null) {
          let emailWrapper = document.createElement('div');
          emailWrapper.classList.add('email-wrapper');
          emailWrapper.innerHTML = '<label for="email_resubmit" class="visually-hidden">Email*</label>'
            + '<input autocomplete="email" type="email" id="email_resubmit" name="email" placeholder="email*" class="input" spellcheck="false" autocapitalize="off" value="" required aria-required="true">'
            + '<a href="#quiz-resubmit" class="btn btn--overlay btn--small btn--primary"><span>send</span></a>';
          
          resultLink.parentElement.appendChild(emailWrapper);

          document.querySelector('a[href="#quiz-resubmit"]').addEventListener('click', (evt) => {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            evt.stopPropagation();
      
            let email = document.getElementById('email_resubmit');
            let isValid = validate(email, document.querySelector('.email-wrapper'));
            
            if (!isValid) return;
      
            window._learnq.push(['identify', {
              '$email': email.value
            }]);
            setTimeout((e) => {
              console.info('resend the quiz result!');
              window._learnq.push(['track', 'Send Quiz']);
            }, 1000);
      
            document.querySelector('.email-wrapper').remove();
            let successMsg = document.createElement('p');
            successMsg.classList.add('success-message');
            successMsg.textContent = 'your results have been sent to your inbox.';
      
            resultLink.parentElement.parentElement.after(successMsg);
      
            gtag("event", "click", {
              "event_category": "quiz",
              "event_label": 'resend quiz'
            });
      
          });
        } else {
          document.querySelector('.email-wrapper').remove();
        }
      });
    }
  });
}

// Collection video play
document.querySelectorAll('.premade-product-item').forEach(item => {
  const playBtn = item.querySelector('[data-play-button]');
  const videoContainer = item.querySelector('[data-video-container]');
  const thumbnail = item.querySelector('[data-video-thumbnail]');

  playBtn.addEventListener('click', function () {
    thumbnail.style.display = 'none';
    videoContainer.style.display = 'block';
    const video = videoContainer.querySelector('video');
    video.play();
  });
});

if (window.location.pathname.includes('/pages/quiz')) {
  document.addEventListener('DOMContentLoaded', function() {
    const urlParams = new URLSearchParams(window.location.search);
    const option = urlParams.get('option');
    const referrer = document.referrer || '';

    if (
      (referrer.includes('/collections/premade-staks') || referrer.includes('/pages/buildmystack')) &&
      !referrer.includes('/pages/quiz') &&
      (option === 'full' || option === 'barely')
    ) {
      const stepSelector =
        option === 'full'
          ? '.new-quiz .image-hero__text-container-wrapper .btn[data-jumpstep="14"]'
          : '.new-quiz .image-hero__text-container-wrapper .btn[data-jumpstep="7"]';

      const stepElement = document.querySelector(stepSelector);
      if (stepElement) {
        stepElement.click();
      }
    }
  });
}

var validate = (element, container) => {
  // Validate the field
  var error = hasError(element);

  // If there's an error, show it
  if (error && container.querySelector('.error-message') == null) {
    let error_p = document.createElement("p");
    error_p.append("This question is required.");
    error_p.classList.add('error-message');
    if (container.querySelector('.rich-text__heading')) {
      container.querySelector('.rich-text__heading').after(error_p);
    } else {
      container.prepend(error_p);
    }

    container.querySelectorAll('input[required]').forEach((e) => {
      e.classList.add('error');
    });
    return false;
  } else if (error && container.querySelector('.error-message')) { 
    // error exist on page
    return false;
  } else if (container.querySelector('.error-message')) {
    // Otherwise, remove any existing error message
    container.querySelectorAll('input[required]').forEach((e) => {
      e.classList.remove('error');
    });
    container.querySelector('.error-message').remove();
    return true;
  }

  return true;
}

var hasError = (field) => {
  // Don't validate submits, buttons, file and reset inputs, and disabled fields
  if (field.type === 'submit' || field.type === 'button') return;

  // Get validity
  let validity = field.validity;

  // If valid, return null
  if (validity.valid) return;

  // If field is required and empty
  if (validity.valueMissing) return true;

  // If not the right type
  if (validity.typeMismatch) {
    // Email
    if (field.type === 'email') return true;
  }
  return false;

};

// new js for country selector

function initCountrySelectors() {
  // Find all country selector containers
  const countrySelectors = document.querySelectorAll('.common-selected_country');
  
  countrySelectors.forEach(selectedCountryBtn => {
    // Skip if already bound
    if (selectedCountryBtn.classList.contains('bound')) {
      return;
    }
    
    selectedCountryBtn.classList.add('bound');
    
    // Find the dropdown within the same container
    const countryDropdown = selectedCountryBtn.nextElementSibling || 
                           selectedCountryBtn.parentElement.querySelector('.common-country_selector');
    
    // Toggle dropdown visibility on click
    selectedCountryBtn.addEventListener('click', function() {
      if (countryDropdown && countryDropdown.classList.contains('visually-hidden')) {
        countryDropdown.classList.remove('visually-hidden');
      } else if (countryDropdown) {
        countryDropdown.classList.add('visually-hidden');
      }
    });
    
    // Find all buttons within this dropdown
    if (countryDropdown) {
      const countryDropdownButtons = countryDropdown.querySelectorAll('button[data-country]');
      countryDropdownButtons.forEach(button => {
        // Skip if already bound
        if (button.classList.contains('bound')) {
          return;
        }
        
        button.classList.add('bound');
        button.addEventListener('click', function(evt) {
          evt.preventDefault();
          const country = button.dataset.country;
          if (countryDropdown && selectedCountryBtn) {
            // Hide the dropdown
            countryDropdown.classList.add('visually-hidden');
            // Update selected country data attribute
            selectedCountryBtn.dataset.country = country;
            // Trigger disclosure form to change country/currency
            const disclosureOption = document.querySelector('[data-disclosure-option][data-value="' + country + '"]');
            if (disclosureOption) {
              disclosureOption.click();
            }
          }
        });
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initCountrySelectors();
});

/* ============================================================
   Filter Bar — Keep badge count in sync with active filters
   ============================================================
   filterBar.renderFilters() (theme.js) updates [data-active-filters]
   after every AJAX render, but does NOT update the Filter button's
   innerHTML because it no longer has data-dropdown-toggle.
   We use a MutationObserver on [data-active-filters] to detect
   the update and recalculate the badge count ourselves.
   ============================================================ */
(function () {
  function updateFilterBarBadge() {
    var filterBar = document.querySelector('[data-filter-bar]');
    if (!filterBar) return;

    var btn = filterBar.querySelector('.filter-bar__button--filters');
    if (!btn) return;

    // Get the Sale filter param name from the inline checkbox so we can exclude it
    var saleInput = filterBar.querySelector('.filter-bar__sale-checkbox');
    var saleParam = saleInput ? saleInput.name : null;

    // Count active-filter pill links, excluding Product Type and Sale
    var activeFiltersEl = filterBar.querySelector('[data-active-filters]');
    var count = 0;

    if (activeFiltersEl) {
      activeFiltersEl.querySelectorAll('[data-remove-filter]').forEach(function (link) {
        var paramName = link.getAttribute('data-name') || '';
        // Exclude Product Type (param contains "product_type")
        if (paramName.indexOf('product_type') !== -1) return;
        // Exclude Sale (boolean) param
        if (saleParam && paramName === saleParam) return;
        count++;
      });
      // Count active price range
      count += activeFiltersEl.querySelectorAll('[data-remove-range]').length;
    }

    // Update badge
    var badge = btn.querySelector('[data-active-filter-count]');
    if (count > 0) {
      if (badge) {
        badge.textContent = count;
      } else {
        badge = document.createElement('span');
        badge.className = 'filter-bar__button-count';
        badge.setAttribute('data-active-filter-count', '');
        badge.textContent = count;
        btn.appendChild(badge);
      }
    } else {
      if (badge) badge.remove();
    }
  }

  function initFilterBarBadgeObserver() {
    var filterBar = document.querySelector('[data-filter-bar]');
    if (!filterBar) return;

    var activeFiltersEl = filterBar.querySelector('[data-active-filters]');
    if (!activeFiltersEl) return;

    // Run once on load to correct any server-rendered mismatch
    updateFilterBarBadge();

    // Watch for DOM changes triggered by filterBar.renderFilters() AJAX updates
    var observer = new MutationObserver(function () {
      updateFilterBarBadge();
    });

    observer.observe(activeFiltersEl, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterBarBadgeObserver);
  } else {
    initFilterBarBadgeObserver();
  }
})();

/* ============================================================
   Filter Drawer — Keep "View (n)" button count in sync
   ============================================================
   After every AJAX render the theme updates [data-results-count]
   elements.  We watch the filter-bar's results-count node and
   mirror the numeric value into the [data-results-count-apply]
   span inside the filter-drawer footer button.
   ============================================================ */
(function () {
  function syncApplyCount() {
    // Try to read the count from the (visually-hidden) results-count
    // paragraph that lives inside the filter-drawer form, since the
    // theme's renderFilters() updates every [data-results-count] node.
    var sourceEl = document.querySelector('.filter-drawer [data-results-count]');
    if (!sourceEl) {
      // Fallback: filter-bar results count paragraph
      sourceEl = document.querySelector('.filter-bar [data-results-count]');
    }
    if (!sourceEl) return;

    // Extract just the number from text like "20 products" or "20 results"
    var text = sourceEl.textContent || '';
    var match = text.match(/\d[\d,]*/);
    var count = match ? match[0].replace(/,/g, '') : null;
    if (!count) return;

    document.querySelectorAll('[data-results-count-apply]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function initApplyCountObserver() {
    // Observe the filter-bar's active-filters zone (already mutated by
    // the theme's AJAX handler) as a reliable "page updated" signal.
    var filterBar = document.querySelector('[data-filter-bar]');
    var activeFiltersEl = filterBar && filterBar.querySelector('[data-active-filters]');

    // Also observe the results-count element directly if present
    var resultsCountEl = document.querySelector('.filter-drawer [data-results-count]')
                      || document.querySelector('.filter-bar [data-results-count]');

    syncApplyCount();

    var observer = new MutationObserver(syncApplyCount);
    var opts = { childList: true, subtree: true, characterData: true };

    if (activeFiltersEl) observer.observe(activeFiltersEl, opts);
    if (resultsCountEl)  observer.observe(resultsCountEl,  opts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initApplyCountObserver);
  } else {
    initApplyCountObserver();
  }
})();
/* ============================================================
   Filter Drawer — Close panel after "Clear All Filters"
   ============================================================
   The theme's clear-all handler unchecks inputs + calls updateFilters()
   but never calls clickWash() (close). We click [data-drawer-wash]
   programmatically right after to dismiss the panel.
   ============================================================ */
(function () {
  document.addEventListener('click', function (e) {
    var clearBtn = e.target.closest('.filter-drawer__button-clear[data-button="clear-all"]');
    if (!clearBtn) return;
    var drawer = clearBtn.closest('[data-filter-drawer]');
    if (!drawer) return;
    var wash = drawer.querySelector('[data-drawer-wash]');
    if (wash) {
      // Small delay so the theme's own clear-all handler runs first
      setTimeout(function () { wash.click(); }, 50);
    }
  });
})();
